import { createVNode, render, VNode } from 'vue';
import ToastConstructor from './toast.vue';
import type { IToastInstance, IToastOptions, IToastNormalized } from './toast-types';

const instances: IToastInstance[] = [];
let seed = 0;

const defaultOptions = {};
const normalizeOptions = (options: IToastOptions | string): IToastNormalized => {
  if (typeof options === 'string') {
    options = { message: options };
  }

  const normalized = { ...defaultOptions, ...options };

  let appendTo: HTMLElement | null = null;

  if (typeof options.appendTo === 'undefined') {
    appendTo = document.body;
  }

  if (typeof options.appendTo === 'string') {
    appendTo = document.querySelector(options.appendTo);
  }

  if (options.appendTo instanceof HTMLElement || options.appendTo === null) {
    appendTo = options.appendTo;
  }

  normalized.appendTo = appendTo;

  return normalized as IToastNormalized;
};


const toast = (options: IToastOptions | string) => {
  if (import.meta.env.SSR) {
    return;
  }
  const normalized = normalizeOptions(options);

  if (!(normalized.appendTo instanceof HTMLElement)) {
    return;
  }

  const userOnClose = normalized.onClose;

  const container = document.createElement('div');
  container.className = 'toast-container';

  const props = {
    ...normalized,
    id: ++seed,
    onClose: () => {
      userOnClose?.();
      close(seed);
    },
    onDestroy: () => {
      render(null, container);
      normalized.appendTo.removeChild(container);
    },
  };

  const vnode: VNode = createVNode(
    ToastConstructor,
    props,
  );

  render(vnode, container);

  const vm = vnode.component;
  const instance: IToastInstance = {
    id: seed,
    vnode,
    vm: vnode.component,
    close: () => vm?.exposeProxy?.close(),
    changeMessage: (msg: string) => vm.props.message = msg,
  };

  instances.push(instance);

  normalized.appendTo.appendChild(container);

  return instance;
};

function close(id: number): void {
  const idx = instances.findIndex(instance => instance.id === id);

  if (idx === -1) {
    return;
  }
  const instance = instances[idx];
  instances.splice(idx, 1);
  instance.close();
}

export default toast;
